export default __webpack_public_path__ + "static/life-grid-green-min-11106986e191aa2047ce565a9462f84b.png";